import dayjs, { Dayjs } from "dayjs";

export const isWeekend = (date: Dayjs = dayjs()): boolean => {
  const day = date.day();
  return day === 0 || day === 6;
};

// 현재 날짜로부터 N개월 후의 만기일 계산
export const calculateMaturityDate = (months: number): string => {
  const maturityDate = new Date();
  maturityDate.setMonth(maturityDate.getMonth() + months);

  const year = maturityDate.getFullYear();
  const month = maturityDate.getMonth() + 1;
  const day = maturityDate.getDate();

  return `${year}년 ${month}월 ${day}일`;
};
